module.exports = __webpack_public_path__ + "static/media/c-female.7a93c6e0.png";